<template>
  <b-field
    grouped
    group-multiline
    label="Catégories"
    message="Ces categories déclencheront les événements du geofence"
  >
    <b-checkbox-button
      v-for="category in liveCategories"
      :key="category.id"
      :value="liveCategoryIds"
      :native-value="category.id"
      :type="`is-${category.color}`"
      @input="$emit('update:liveCategoryIds', $event)"
    >
      {{ category.name }}
    </b-checkbox-button>
  </b-field>
</template>

<script>
export default {
  name: 'CategoryField',

  props: {
    liveCategories: {
      type: Array,
      default: () => [],
    },
    liveCategoryIds: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
